import { logOut } from "../redux/authReducer/actions";
import CryptoService from "./CryptoService";
import { HttpMethod } from "./HttpService";
import SessionService from "./SessionService";

abstract class AuthorizationService {
  public static authorizedFetch = (
    input: RequestInfo,
    init?: RequestInit
  ): Promise<Response> =>
    SessionService.getNonce()
      .then(nonce => {
        let message;
        if (init !== undefined) {
          switch (init.method) {
            case HttpMethod.Delete: {
              const url = new URL(input.toString());
              const queryString = url.search.slice(1);
              message = queryString;
              break;
            }
            case HttpMethod.Get: {
              const url = new URL(input.toString());
              const queryString = url.search.slice(1);
              message = queryString;
              break;
            }
            case HttpMethod.Post: {
              const body = init.body;
              if (body !== undefined && body !== null) {
                message = body.toString();
              }
              break;
            }
            case HttpMethod.Put: {
              const body = init.body;
              if (body !== undefined && body !== null) {
                message = body.toString();
              }
              break;
            }
          }
        }
        const mac = CryptoService.generateMac(nonce, message);
        const newInit = {
          ...init,
          headers: {
            ...(init !== undefined && init.headers),
            Mac: mac
          }
        };
        return fetch(input, newInit);
      })
      .then(response => {
        if (response.status === 401) {
          throw new Error("Authorization error");
        } else {
          return response;
        }
      })
      .catch(error =>
        SessionService.clearSession()
          .then(async () => {
            // await logOut()
            window.location.reload();
          })
          .then(() => {
            throw error;
          })
      );

  /**
   * Use this method for requests with `multipart/form-data`.
   *
   * This method is similar to [[authorizedFetch]], except that the MAC
   * signature is calculated from the [[Request]] body. This is necessary for
   * cases where the the [[Request]] body is dynamically generated in the
   * constructor when creating a [[Request]] instance.
   *
   * For example, requests with [[FormData]] need to create a [[Request]]
   * instance first before calculating the MAC directly from the [[FormData]].
   * The [[Request]] instance will generate a message body from the provided
   * [[FormData]]. The generated body can then be used to calculated the MAC
   * signature.
   */
  public static authorizedFetchWithFormData = (
    input: RequestInfo,
    init?: RequestInit
  ): Promise<Response> => {
    const request = new Request(input, init);
    return SessionService.getNonce().then(nonce => {
      const requestClone = request.clone();
      return requestClone.arrayBuffer().then(arrayBuffer => {
        const mac = CryptoService.generateMacFromArrayBuffer(
          nonce,
          arrayBuffer
        );
        request.headers.append("Mac", mac);
        return fetch(request);
      });
    });
  };
}

export default AuthorizationService;
